export default __webpack_public_path__ + "static/media/ic_fuelMeter.28d2cb8d.svg";